import { useMemo, useState } from "react";
import { currencyFormatter, dataGridTablePlainStyles } from 'utils/index';
import { EditCalendar, EventSeat } from "@mui/icons-material";
import { format, parse, } from "date-fns";
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Button, Grid, Box, Stack, Typography } from "@mui/material";

const BookingsDesktopView = ({bookings=[], refreshData, addBooking, editBooking, onDeleteBtnClick, checkInInmate, permissions={}}) => {
  const { isAddBookingsAllowed, isEditBookingsAllowed } = permissions;
  const [pageSize, setPageSize] = useState(25);

  const RowWrapper = ({children}) => <Box sx={{my: 1, width: '100%'}}>{children}</Box>;

  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{justifyContent:"right"}}>
        <GridToolbarQuickFilter />
        {/* <GridToolbarExport /> */}
      </GridToolbarContainer>
    );
  }

  const columns = useMemo(() => [
    { field: 'bookingDate', headerName: 'Booking date',flex: 1, minWidth: 140, sortable: false,
    renderCell: ({ row }) => (
      <RowWrapper>
          <Typography variant="subtitle2" fontWeight={500}>{format(parse(row.bookingDate, 'dd-MM-yyyy', new Date()),'dd-MMM-yyyy')}</Typography>
          {row?.bookingAmount ? <Typography variant="caption">Amount Paid: {currencyFormatter.format(row.bookingAmount)}</Typography> : null}
      </RowWrapper>
      
    )},
    { field: 'name', headerName: 'Contact details', flex: 1, minWidth: 180,
      renderCell: ({row}) => (
        <RowWrapper>
          <Typography variant="subtitle1" fontWeight={500}>{row.name}</Typography>
          <Typography variant="body2" >{row.mobileNumber}</Typography>
          {row?.email ? <Typography variant="caption" >{row.email}</Typography> : null}
        </RowWrapper>
      ),
      getApplyQuickFilterFn: (value) => { //9748332345
        return (params) => {
          const { joiningDate, bookingDate, bedInfo, bookingAmount='', comments } = params?.row || {};
          return params && (
            params?.value?.includes(value) || 
            params?.row?.mobileNumber?.includes(value) || 
            params?.row?.email?.includes(value) || 
            (joiningDate && format(parse(joiningDate, 'dd-MM-yyyy', new Date()), 'MMM dd, yyyy')?.includes(value)) || 
            (bookingDate && format(parse(bookingDate, 'dd-MM-yyyy', new Date()), 'dd-MMM-yyyy')?.includes(value)) || 
            bedInfo?.includes(value) ||
            bookingAmount?.toString()?.includes(value) || 
            comments?.includes(value)
          )
        };
      }
    },
    { field: 'joiningDate', headerName: 'Joining date', type: 'date', flex: 1, minWidth: 140,
      valueGetter: ({ value }) => value && parse(value, 'dd-MM-yyyy', new Date()),
      renderCell: ({value}) =>  (
        <RowWrapper>
          <Typography variant="body2" >{value ? format(value, 'MMM dd, yyyy') : '-'}</Typography>
        </RowWrapper>
      )
    },
    { field: 'comments', headerName: 'Comments',   flex: 1, minWidth: 220 },
    // { field: 'status', headerName: 'Status',  flex: 1,  minWidth: 120,
    //   headerAlign: 'center',
    //   renderCell: ({value}) => (
    //     <RowWrapper>
    //       <Typography textAlign="center" variant="body2" sx={{color: statusColorCode[value], fontWeight: 500}}>{value}</Typography>
    //     </RowWrapper>
    //   )
    // },
    { field: 'actions',  type: 'actions', minWidth: 320, flex: 2, align: 'left', getActions: ({row}) => [
      <Button 
        startIcon={<EventSeat />} 
        size="small" 
        sx={{ml: 1,  px: 2, fontSize: 13, fontWeight: 400}} 
        variant="tonal" 
        color="primary"
        onClick={() => checkInInmate(row)}
      >
        Check-In
      </Button> 
      ,
      isEditBookingsAllowed ? <Button 
        startIcon={<EditCalendar />} 
        size="small" 
        sx={{ml: 1,  px: 1.8, fontSize: 13, fontWeight: 400}} 
        variant="outlined" 
        color="secondary"
        onClick={() => editBooking(row)}
      >
        Edit
      </Button> : <></>
      ,
      isEditBookingsAllowed ? <Button 
        // startIcon={<EventBusyRounded />} 
        size="small" 
        sx={{ px: 1, fontSize: 13, fontWeight: 400}} 
        // variant="outlined" 
        color="error"
        onClick={() => onDeleteBtnClick(row.id)}
      >
        Cancel
      </Button> : <></>
    ]} 
  ],[editBooking, onDeleteBtnClick, checkInInmate, isEditBookingsAllowed]);

  return (
    <>
      <Grid item xs={12}  display={{xs: 'none', md: 'block'}}>
        <Stack direction="row" columnGap={1} justifyContent="right">
          <Button onClick={refreshData}>Refresh</Button>
          {isAddBookingsAllowed ? <Button color="tertiary" variant="tonal" onClick={addBooking}>New Booking</Button> : null}
        </Stack>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt:2, mb: {xs: 10, md: 2}}}>
        <Box sx={{ height: '500px',width: '100%' }}>
            <DataGrid 
              rows={bookings}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[10,25,50,100,150]}
              getRowId={(row) => row.id}
              getRowHeight={() => 'auto'}
              hideFooterSelectedRowCount
              disableSelectionOnClick
              // density='comfortable'
              // getColumnSpacing={()=> 5}
              autoHeight={bookings.length <= 8 ? true: false}
              sx={{...dataGridTablePlainStyles}}
              disableColumnSelector
              disableDensitySelector
              disableRowSelectionOnClick
              slots={{ toolbar: CustomToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              localeText={{ noRowsLabel: "No bookings to show" }}
            />
        </Box>
      </Grid>
    </>
  );
}
 
export default BookingsDesktopView;